module.exports = __webpack_public_path__ + "resource/img/Toxic.e83d113e.png";